export const scatteredHabits = [
  'You save a foot chart.',
  'Then another one.',
  'You watch a reflexology video.',
  'You download a PDF.',
  'You take notes.',
  'You bookmark a lesson.',
];

export const selfQuestions = [
  'What should I practice today?',
  'Where should I start?',
  'What should I review first?',
  'Am I actually making progress?',
];

export const fourSteps = [
  { label: 'Learn', text: 'One focused concept' },
  { label: 'Practice', text: 'A guided exercise' },
  { label: 'Record', text: 'Note what you did' },
  { label: 'Review', text: 'Reinforce & track' },
];

export const beforeItems = [
  "You have several reflexology charts but don't know which one to use.",
  "You have saved videos and lessons but don't know what to review next.",
  'You study whenever you have time, without a consistent structure.',
  'You spend more time deciding what to practice than actually practicing.',
  'You learn something and then struggle to remember it later.',
  "You keep telling yourself you'll practice more consistently.",
  'You feel like you need to learn "just a little more" before you start practicing.',
];

export const afterItems = [
  "You open the day you're on and immediately know what to do.",
  'You spend approximately 15 minutes following a structured practice session.',
  'You review reflexology fundamentals progressively.',
  'You practice instead of endlessly consuming more information.',
  "You record what you've practiced.",
  'You review your progress each week.',
  "After 21 days, you'll have a clear record of the work you've completed.",
];

export const pains = [
  "You have reflexology resources everywhere, but you don't have a clear study and practice routine.",
  'You want to practice more consistently, but you feel like you never have enough time.',
  "You sit down to study reflexology and aren't sure what you should focus on that day.",
  "You've collected charts, books, videos, notes, and PDFs — but they're scattered across different places.",
  'You start practicing with motivation, but after a few days your routine disappears.',
  "You know you need more practice, but you don't have a simple system that tells you what to do next.",
];

export const extras = [
  { title: '21 Daily Practice Sheets', text: 'One dedicated sheet for each day of the method.' },
  { title: 'Daily Practice Checklists', text: "Simple checklists to help you complete each day's practice." },
  { title: 'Study & Review Prompts', text: "Questions designed to help you actively review what you're learning." },
  { title: 'Progress Trackers', text: 'Track your completed days, practice sessions, reviews, and areas you want to revisit.' },
  { title: 'Practice Roadmaps', text: 'Visual guides showing where you are and what comes next.' },
];

export const offerIncludes = [
  'One-time payment',
  'Lifetime access',
  'No monthly fees',
  'Instant digital access',
  '6 premium volumes',
  '5 exclusive bonuses',
];

export const guaranteeItems = [
  'Explore all 6 volumes',
  'Start Day 1',
  'Use the daily practice sheets',
  'Review the study cards',
  'Use the practice planner',
  'Test the checklists',
  'Explore all 5 bonuses',
];

export const finalSummary = [
  '6 premium volumes',
  '5 exclusive bonuses',
  '21 days of guided practice',
  '15 minutes a day',
  'Study cards + planners + checklists',
  'Quick-reference tools',
];
